import { ALL_CATEGORIES_QUERY, ALL_GRID_CATEGORIES_QUERY } from 'app-constants/categories';
import { getCombinedState, useDocument, useLiveData } from 'hooks';
import { ColoringGridDBO } from 'jpu-shared/models/DBOs/ColoringGridDBO';
import { PuzzleDBO } from 'jpu-shared/models/DBOs/PuzzleDBO';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { GetQueryProps } from 'services/api/firestore';

export const useFirstApprovalData = () => {
  const { id: artistId } = useParams<{ id: string }>();

  const {
    snapshot: artistSnapshot,
    state: artistFetchState,
    error: artistFetchError,
  } = useDocument(`usersWeb/${artistId}`, true);

  const {
    docs: categoriesSnapshot,
    state: categoriesFetchState,
    error: categoriesFetchError,
  } = useLiveData(ALL_CATEGORIES_QUERY);

  const {
    docs: gridsCategoriesSnapshot,
    state: gridsCategoriesFetchState,
    error: gridsCategoriesFetchError,
  } = useLiveData(ALL_GRID_CATEGORIES_QUERY);

  const artistPuzzlesQuery = useMemo<GetQueryProps<PuzzleDBO> | null>(() => {
    if (!artistId) return null;

    return {
      collectionPath: 'puzzles',
      filters: [{ attribute: 'Publisher', operator: '==', value: artistId }],
      ordering: [{ type: 'asc', field: 'createdAt' }],
    };
  }, [artistId]);

  const artistColoringGridsQuery = useMemo<GetQueryProps<ColoringGridDBO> | null>(() => {
    if (!artistId) return null;

    return {
      collectionPath: 'coloringGrids',
      filters: [{ attribute: 'publisher', operator: '==', value: artistId }],
      ordering: [{ type: 'asc', field: 'createdAt' }],
    };
  }, [artistId]);
  const {
    docs: puzzlesSnapshot,
    state: puzzlesFetchState,
    error: puzzlesFetchError,
  } = useLiveData<PuzzleDBO>(artistPuzzlesQuery);

  const {
    docs: gridsSnapshot,
    state: gridsFetchState,
    error: gridsFetchError,
  } = useLiveData<ColoringGridDBO>(artistColoringGridsQuery);

  const errors = [
    artistFetchError,
    categoriesFetchError,
    puzzlesFetchError,
    gridsCategoriesFetchError,
    gridsFetchError,
  ];
  const state = getCombinedState(
    artistFetchState,
    categoriesFetchState,
    puzzlesFetchState,
    gridsCategoriesFetchState,
    gridsFetchState,
  );

  return {
    state,
    artistSnapshot,
    categoriesSnapshot,
    puzzlesSnapshot,
    gridsCategoriesSnapshot,
    gridsSnapshot,
    errors,
  };
};
